// extracted by mini-css-extract-plugin
export default {"container":"sS-z","topReviewHeading":"tS-z","criticalReview":"uS-z","favorableReview":"vS-z","vsSeparator":"wS-z"};